import React, { useState } from "react";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import FormComponent from "../../Common/Form/Form";

const LoanForm = () => {
  const [selected, setSelected] = useState(1);

  const radio = [
    {
      label: "Less than $1,000",
    },
    {
      label: "$1,000 - $5,000",
    },
    {
      label: "$5,001 - $10,000",
    },
    {
      label: "$5,001 - $10,000",
    },
  ];

  const handleChange = (e) => {};

  return (
    <section className={s.form_container}>
      <div className={s.form_wrapper}>
        <div className={s.form_header}>
          <h3 className="heading">Hello Dear Customer,</h3>
          <p className={secondaryFont}>
            Please fill in the following details for us to offer you a
            collateral loan.
          </p>
        </div>

        <FormComponent
          buttonText="Get a loan offer now"
          placeholderText="Please describe your items to keep as collateral."
          eventText="form_submit_collateral_loan"
        />

        {/* <Form>
          <Row>
            <Col xs={6}>
              <FloatingLabel label="Your First Name">
                <Form.Control type="text" placeholder="Your First Name" />
              </FloatingLabel>
            </Col>
            <Col xs={6}>
              <FloatingLabel label="Your Last Name">
                <Form.Control type="text" placeholder="Your Last Name" />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="my-3">
              <FloatingLabel label="Your Email">
                <Form.Control type="text" placeholder="Your Email" />
              </FloatingLabel>
            </Col>
            <Col xs={12}>
              <FloatingLabel label="Your Mobile Number">
                <Form.Control type="text" placeholder="Your Mobile Number" />
              </FloatingLabel>
            </Col>
          </Row>
          <div className={s.radio_button_wrapper}>
            <p className={`${secondaryFont} sub-title`}>Select Loan Range</p>
            <div
              className={`row align-items-center ${s.radio_buttons}`}
              onChange={handleChange}
            >
              {radio.map(({ label }, idx) => {
                return (
                  <Col
                    xs={6}
                    className={`mb-2 ${selected === idx + 1 ? s.active : ""} ${
                      s.radio_button
                    }`}
                    onClick={() => {
                      setSelected(idx + 1);
                    }}
                  >
                    <Form.Check
                      type="radio"
                      id={idx + 1}
                      label={label}
                      name="loan range"
                      value={idx + 1}
                      checked={idx + 1 === selected}
                      className={secondaryFont}
                    />
                    <div className={`${s.checked}`}>
                      <img loading="lazy" src={Check.src} alt="image" height="100%"/>
                    </div>
                  </Col>
                );
              })}
            </div>
          </div>
          <button
            className="btn btn-primary w-100 justify-content-center fw-bold"
            type="submit"
          >
            Next <IoArrowForward size="22px" />
          </button>
        </Form> */}
      </div>
    </section>
  );
};

export default LoanForm;
